import React, { useCallback, useEffect, useState } from "react";
import "./AchieversPage.css";
import CloseIcon from "@mui/icons-material/Close";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import DownloadIcon from "@mui/icons-material/Download";
import achiever1 from "../assets/images/Achivers1.jpeg";
import achiever2 from "../assets/images/Achivers2.jpeg";
import achiever3 from "../assets/images/Achivers3.jpeg";

const achieversPhotos = [achiever1, achiever2, achiever3];

function AchieversPage() {
  const [selectedIndex, setSelectedIndex] = useState(null);

  const closeLightbox = useCallback(() => setSelectedIndex(null), []);

  useEffect(() => {
    if (selectedIndex === null) return undefined;

    const handleKeyDown = (e) => {
      if (e.key === "Escape") closeLightbox();
    };
    document.addEventListener("keydown", handleKeyDown);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
    };
  }, [selectedIndex, closeLightbox]);

  return (
    <div className="achievers-page-bg">
      <div className="achievers-root">
        <h1 className="achievers-title">Achievers</h1>
        <div className="achievers-gallery">
          {achieversPhotos.map((photo, idx) => (
            <div
              className="achievers-photo-card"
              key={idx}
              role="button"
              tabIndex={0}
              aria-label={`View Achiever ${idx + 1} photo full size`}
              onClick={() => setSelectedIndex(idx)}
              onKeyDown={(e) =>
                (e.key === "Enter" || e.key === " ") && setSelectedIndex(idx)
              }
            >
              <img
                src={photo}
                alt={`Achiever ${idx + 1}`}
                className="achievers-photo"
              />
              <span className="achievers-zoom-badge">
                <ZoomInIcon fontSize="small" />
              </span>
            </div>
          ))}
        </div>
      </div>

      {selectedIndex !== null && (
        <div className="achievers-lightbox-backdrop" onClick={closeLightbox}>
          <div
            className="achievers-lightbox-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="achievers-lightbox-image-wrap">
              <button
                type="button"
                className="achievers-lightbox-close"
                onClick={closeLightbox}
                aria-label="Close"
              >
                <CloseIcon fontSize="small" />
              </button>
              <img
                src={achieversPhotos[selectedIndex]}
                alt={`Achiever ${selectedIndex + 1}`}
                className="achievers-lightbox-img"
              />
              <a
                href={achieversPhotos[selectedIndex]}
                download={`Achiever-${selectedIndex + 1}.jpeg`}
                className="achievers-lightbox-save"
              >
                <DownloadIcon fontSize="small" />
                Save Image
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AchieversPage;
